import styled from "styled-components";

interface IdentifierProps {
  active: boolean;
}

const Container = styled.div`
  padding: 0 30px 50px 30px;

  > :not(:last-child) {
    margin-bottom: 15px;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconsContainer = styled.div`
  display: flex;
`;

const FilterButton = styled.button`
  cursor: pointer;
  margin-right: 15px;
  border: none;
  background-color: transparent;
  position: relative;
`;

const Identifier = styled.i<IdentifierProps>`
  position: absolute;
  width: 20px;
  height: 4px;
  border-radius: 10px;
  transition: all 0.5s ease-in-out;
  background-color: ${({ theme }) => theme.colors.tertiary};
  display: ${(props) => (props.active ? "block" : "none")};
`;

export { Container, HeaderContainer, IconsContainer, FilterButton, Identifier };
